module.exports = __webpack_public_path__ + "d9a8dbb7da0b09e311c3a33db8fa44ab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/chili.png
// module id = 2505
// module chunks = 0